import { inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { filter, map, switchMap, take } from 'rxjs/operators';

import {
  CheckTranslations,
  getTranslationLoading,
  I18nService,
  INFRASTRUCTURE_CONFIG,
  LocalStorageService,
  SetAvailableLanguages,
  SetCurrentLocale,
  SetDefaultLanguageCode
} from '@ui/legacy-lib';
import { UserStore } from '@ui/tenant-pool/shared/user/data-access';

export const TenantTranslationsGuard = () => {
  const store = inject(Store);
  const storage = inject(LocalStorageService);
  const i18nService = inject(I18nService);
  const config = inject(INFRASTRUCTURE_CONFIG);
  const userStore = inject(UserStore);

  return userStore.userDataActionState$.pipe(
    filter(actionState => actionState.done || !!actionState.error),
    take(1),
    switchMap(() => {
      const informal =
        userStore.userData()?.customerBranding?.itpSettings?.informalLanguage ??
        false;
      const localeKey = config.storageKeys.localeKey;
      const currentLocale = storage.getItem(localeKey);
      const appName = config.environment.app_name;
      const languageConfig = i18nService.getInfrastructureLanguageConfig();

      store.dispatch(new CheckTranslations(appName, currentLocale, informal));
      store.dispatch(new SetCurrentLocale(currentLocale));
      store.dispatch(
        new SetAvailableLanguages(languageConfig.availableLanguages)
      );
      store.dispatch(
        new SetDefaultLanguageCode(languageConfig.defaultLanguageCode)
      );

      return store.select(getTranslationLoading).pipe(
        filter(loading => !loading),
        take(1),
        map(() => true)
      );
    })
  );
};
